import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import ItemIcon from '../ItemIcon'
import styles, { itemSize } from './styles'

const SimpleItem = ({ className, icon, theme, size, withBackground, label, children }) => (
  <li className={cx(styles.item, className, itemSize(size))}>
    <ItemIcon icon={icon} theme={theme} size={size} withBackground={withBackground} />

    <span>{children || label}</span>
  </li>
)

SimpleItem.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  label: PropTypes.string,
  theme: PropTypes.string,
  size: PropTypes.string,
  withBackground: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default SimpleItem
